import { render, staticRenderFns } from "./FooterInfos.vue?vue&type=template&id=6a1a671d&scoped=true"
import script from "./FooterInfos.vue?vue&type=script&lang=js"
export * from "./FooterInfos.vue?vue&type=script&lang=js"
import style0 from "./FooterInfos.vue?vue&type=style&index=0&id=6a1a671d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a671d",
  null
  
)

export default component.exports